module.exports = __webpack_public_path__ + "img/login1.43513b57.png";